const headerNavLinks = [
  { href: '/', title: 'Home' },
  { href: '/blog', title: 'Blog' },
  { href: '/tags', title: 'Tags' },
  // { href: '/projects', title: 'Projects' },
  { href: '/about', title: 'About' },
  { href: '/categories/thought', title: 'Thought' },
  { href: '/categories/moment', title: 'Moment' },
  { href: '/categories', title: 'Category' },
];

export default headerNavLinks;
